import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3001';
const fmtET = (iso) => new Intl.DateTimeFormat('en-US', { timeZone:'America/New_York', weekday:'long', month:'short', day:'numeric', hour:'numeric', minute:'2-digit' }).format(new Date(iso)) + ' ET';

export default function AppointmentsView() {
  const { authFetch } = useAuth();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    authFetch(`${API_BASE}/api/leads/appointments`).then(r => r.json())
      .then(d => setRows(d.data || [])).catch(() => setRows([]));
  }, [authFetch]);
  if (rows === null) return <div className="ws-pulse">Loading…</div>;
  if (rows.length === 0) return (
    <div className="sol-empty">
      <h3>No upcoming appointments</h3>
      <p>Booked callbacks appear here.</p>
    </div>
  );
  return (
    <div>
      <div className="ws-label">Upcoming callbacks</div>
      {rows.map((a) => (
        <div key={a.id} className="ws-card">
          <div className="ws-row" style={{ borderBottom: 'none', padding: 0 }}>
            <span>{a.property_address || a.owner_full_name || 'Lead'}</span>
            <span>{fmtET(a.scheduled_for)}</span>
          </div>
          {a.phone_primary && <div className="ws-src" style={{ marginTop: 4 }}>{a.phone_primary}</div>}
        </div>
      ))}
    </div>
  );
}
